import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Vehicle} from '@app/interfaces';
import {Router} from '@angular/router';
import { isBrowser } from '@app/util/is-browser';

@Component({
    selector: 'app-global-search-result-card-vehicle',
    templateUrl: './global-search-result-card-vehicle.component.html',
    styleUrls: ['./global-search-result-card-vehicle.component.scss'],
    standalone: false
})
export class GlobalSearchResultCardVehicleComponent {

  @Input() result: Vehicle;

  @Output() onClose: EventEmitter<boolean> = new EventEmitter(false);

  constructor(private router: Router) {
  }

  redirect() {
    this.onClose.emit(true);
    if (isBrowser() && this.router.url.includes(this.result.vehicleUuid)) {
      return window.location.reload();
    } else {
      this.router.navigate([`/admin/vehicles/${this.result.vehicleUuid}`]);
    }
  }
}
